<div class="pageSubHeader">
  <app-section-title
    *ngIf="(screenSizeService.isHandset$ | async) === false"
    svgIcon="file-plus"
    [title]="appendixTitle"
    headerSize="h4"
  ></app-section-title>
</div>

<div *ngIf="(loading$ | async) === false">
  <app-dpr-attachments
    [gridData]="gridData$ | async"
    [namingConvention]="(userDetailsQuery.selectedSubproject$ | async)?.data?.namingConvention"
    [identifier]="'appendix'"
    [canEdit]="canEdit"
    [clientId]="clientId$ | async"
    [isAppOnline]="isAppOnline$ | async"
    [fileUploadConfig]="fileUploadConfig"
    (gridRegistered)="onGridRegistered($event)"
  ></app-dpr-attachments>
</div>
